var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iframeContainer",staticClass:"sp_meeting_widget_container"},[_c('iframe',{ref:"iframe",staticClass:"sp_meeting_widget",style:(_vm.iframeStyle),attrs:{"srcdoc":_vm.embedCode}})])}
var staticRenderFns = []

export { render, staticRenderFns }